import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiClock, FiMail, FiRefreshCw, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { http } from '../api/http';
import styles from './PendingApprovalPage.module.css';

const PendingApprovalPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState<any>(null);

  useEffect(() => {
    // Solo verificar estado si el usuario está autenticado
    if (isAuthenticated) {
      checkStatus();
    }
  }, [isAuthenticated]);

  const checkStatus = async () => {
    setLoading(true);
    try {
      const status = await http<any>('/me/profile/status');
      setUserInfo(status);
      
      // Si ya fue aprobado, redirigir al dashboard
      if (status.user_status === 'ACTIVE') {
        navigate('/dashboard', { replace: true });
      }
    } catch (error) {
      console.error('Error checking status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    if (isAuthenticated) {
      logout();
    }
    navigate('/login');
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconContainer}>
            <FiClock className={styles.icon} />
          </div>
          <h1 className={styles.title}>Cuenta en Revisión</h1>
          <p className={styles.subtitle}>
            Tu cuenta está siendo revisada por nuestro equipo
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.statusCard}>
            <h2 className={styles.statusTitle}>Estado Actual</h2>
            <div className={styles.statusBadge}>
              <FiClock />
              Pendiente de Aprobación
            </div>
            
            {userInfo?.completion_percentage && (
              <div className={styles.progressSection}>
                <p className={styles.progressLabel}>
                  Perfil completado: {userInfo.completion_percentage}%
                </p>
                <div className={styles.progressBar}>
                  <div 
                    className={styles.progressFill}
                    style={{ width: `${userInfo.completion_percentage}%` }}
                  />
                </div>
              </div>
            )}
          </div>

          <div className={styles.infoSection}>
            <h3 className={styles.sectionTitle}>
              <FiMail /> ¿Qué sigue?
            </h3>
            <div className={styles.stepsList}>
              <div className={styles.step}>
                <span className={styles.stepNumber}>1</span>
                <div className={styles.stepContent}>
                  <h4>Revisión de Seguridad</h4>
                  <p>Nuestro equipo está validando tu información de acceso por motivos de seguridad.</p>
                </div>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNumber}>2</span>
                <div className={styles.stepContent}>
                  <h4>Verificación de Datos</h4>
                  <p>Validamos que la información proporcionada sea correcta y consistente.</p>
                </div>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNumber}>3</span>
                <div className={styles.stepContent}>
                  <h4>Aprobación Final</h4>
                  <p>Una vez completada la revisión, recibirás un email con el resultado.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.timelineSection}>
            <h3 className={styles.sectionTitle}>Tiempo Estimado</h3>
            <p className={styles.timelineText}>
              El proceso de revisión usualmente toma entre <strong>1 a 4 horas hábiles</strong>. 
              Te notificaremos por email tan pronto como tengamos una respuesta.
            </p>
          </div>

          <div className={styles.contactSection}>
            <h3 className={styles.sectionTitle}>¿Necesitas Ayuda?</h3>
            <p className={styles.contactText}>
              Si tienes preguntas o necesitas asistencia, 
              contáctanos en <a href="mailto:soporte@profunding.com">soporte@profunding.com</a>
            </p>
          </div>
        </div>

        <div className={styles.actions}>
          {isAuthenticated && (
            <button 
              onClick={checkStatus} 
              disabled={loading}
              className={styles.refreshButton}
            >
              <FiRefreshCw className={loading ? styles.spinning : ''} />
              {loading ? 'Verificando...' : 'Verificar Estado'}
            </button>
          )}

          <button 
            onClick={handleLogout}
            className={styles.logoutButton}
          >
            <FiLogOut />
            {isAuthenticated ? 'Cerrar Sesión' : 'Ir a Iniciar Sesión'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;